import React from "react";

interface InitializationErrorProps {
  error: string;
  onRetry: () => void;
}

const InitializationError: React.FC<InitializationErrorProps> = ({ error, onRetry }) => {
  return (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center", 
      height: "100vh",
      flexDirection: "column",
      gap: "16px",
      padding: "20px"
    }}>
      <div style={{ 
        background: "rgb(var(--color-errorColor) / 0.08)", 
        padding: "20px", 
        borderRadius: "8px",
        border: "1px solid rgb(var(--color-errorColor) / 0.25)",
        textAlign: "center",
        maxWidth: "400px"
      }}>
        <h3 style={{ color: "rgb(var(--color-errorColor))", margin: "0 0 12px 0" }}>Initialization Failed</h3>
        <p style={{ color: "rgb(var(--color-secondTextColor))", margin: "0 0 16px 0" }}>{error}</p>
        <button 
          onClick={onRetry}
          style={{
            background: "rgb(var(--color-buttonColor))",
            color: "rgb(var(--color-variantTextColor))",
            border: "none",
            padding: "8px 16px",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export default InitializationError;